import { computed, ComputedRef } from 'vue'

// State
import store from "@/vue/planning/store/store"
import { getCookie } from '@/utils/utils'
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain"

//ie. https://docs.travelski.com/legal-docs/www.nl.travelski.com/CGV/index.pdf

function cgvHost(hostname: string): string {
    if (hostname === "www.yoonly.eu" || hostname === "www.fr.yoonly.eu" || hostname === "yoonly.eu") {
        return "www.befr.yoonly.eu";
    }
    const site = getSiteFromDomain(hostname);
    if (site === "www.nl.yoonly.eu" || hostname === "www.nl.yoonly.eu") {
        return "www.benl.yoonly.eu";
    }
    return site;
}

const conditionsUrl: ComputedRef<string> = computed(() => {
    const locale: string = String(store.getters.locale).replaceAll("-", "_");
    const hostname = window.location.hostname;
    const onCse = locale === "fr_FR_CSE" || hostname.includes("cse.travelski.com");
    if (onCse) {
        const root = getCookie("companyLang") === "nl"
            ? "cse.travelski.com/Ski%20Schools"
            : "cse.travelski.com/Companies";
        return `https://docs.travelski.com/legal-docs/${root}/CGV/index.pdf?ts=${Date.now()}`;
    }
    return `https://docs.travelski.com/legal-docs/${cgvHost(hostname)}/CGV/index.pdf?ts=${Date.now()}`;
})
export default conditionsUrl